import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2ResponsiblePersonGive = hashCodeCertificate("WaybillV2ResponsiblePersonGive")

export default WaybillV2ResponsiblePersonGive
